/**
 * External Dependencies
 */
import { createApp } from 'vue';
import VueGoodTablePlugin from 'vue-good-table-next';
import vSelect from 'vue-select';
import tooltip from '@/directives/tooltip';
import vModal from '@/plugins/modal';

import VueCookies from 'vue-cookies';

/**
 * Internal Dependencies
 */
import router from './router.js';
import App from './App.vue';
import store from './store';

/**
 * Styles
 */
import 'vue-select/dist/vue-select.css';
import '@vuepic/vue-datepicker/dist/main.css';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import '@/assets/scss/style.scss';

import PopupConfirm from '@/components/popup/popup-confirm';

const app = createApp(App);

app.use(vSelect);
// A local v-tooltip directive (src/directives/tooltip.js) rather than a
// library: see the comment there for why floating-vue did not work out.
app.directive('tooltip', tooltip);
app.use(vModal);
app.use(VueGoodTablePlugin);
app.use(VueCookies);
// vue-clipboard2 is Vue 2 only, and all it provided here was $copyText.
// The Clipboard API covers it, returns a promise just the same, and leaves
// every call site (summary, documents, manage-document) untouched.
app.config.globalProperties.$copyText = function (text) {
	return navigator.clipboard.writeText(text);
};

app.mixin({
	methods: {
		openConfirmModal: function({ title, message, confirm, cancel, onConfirm, onCancel }) {
			this.$modal.show(
				PopupConfirm,
				{
					// `title` is optional: without it the popup keeps its own
					// default, so every existing call site is unchanged.
					...(title ? { title } : {}),
					message: message,
					confirm: confirm,
					cancel: cancel,
					confirmFn: () => {
						if (typeof onConfirm === 'function') onConfirm();

						this.$modal.hide('popupConfirm');
					},
					cancelFn: () => {
						if (typeof onCancel === 'function') onCancel();
						this.$modal.hide('popupConfirm');
					}
				},
				{
					name: 'popupConfirm',
					width: 500
				}
			);
		}
	}
});

app.use(router);
app.use(store);
app.mount('#app');
